var $5b9deeb163e68754$exports = {};
$5b9deeb163e68754$exports = {
    "actions": `Actions`,
    "hideButtonLabel": `Afficher moins`,
    "noTags": `Aucun`,
    "showAllButtonLabel": (args, formatter)=>`Tout afficher (${formatter.number(args.tagCount)})`
};


export {$5b9deeb163e68754$exports as default};
//# sourceMappingURL=fr-FR.mjs.map
